export default {
  meta: {
    title: '商业直租运营图片'
  }
};
